import { useEffect, useState } from 'react';
import { OnConnectStartParams } from '@xyflow/react';

export const useConnectionStartNode = () => {
    const [connectionStartNode, setConnectionStartNode] = useState<OnConnectStartParams | null>(null);

    // Add an effect to highlight valid connection targets
    useEffect(() => {
        if (connectionStartNode) {
            // Add a class to all nodes that can be valid targets
            const nodeElements = document.querySelectorAll('.react-flow__node');
            nodeElements.forEach((nodeEl) => {
                // Don't allow connecting to self
                if (nodeEl.getAttribute('data-id') !== connectionStartNode.nodeId) {
                    nodeEl.classList.add('connecting-possible');
                }
            });

            return () => {
                // Clean up by removing the class from all nodes
                nodeElements.forEach((nodeEl) => {
                    nodeEl.classList.remove('connecting-possible');
                });
            };
        }
    }, [connectionStartNode]);

    return {
        connectionStartNode,
        setConnectionStartNode,
    };
};
